import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import Api from 'src/services/ApiService';
import {
  CommonAxiosResponse,
  EcomOrdersGetRequest,
  EcomOrdersGetResponse
} from 'src/types';
import { sanitizePayloadData } from 'src/utils';

export const getEcomOrderListThunk = createAsyncThunk<
  CommonAxiosResponse<EcomOrdersGetResponse>,
  EcomOrdersGetRequest,
  { state: RootState }
>('ecom/getEcomOrderListThunk', async (data, api) => {
  const request = api?.getState()?.ecomOrders.getEcomOrderListRequest;

  data = {
    ...request,
    ...data,
    limit: 50
  };

  const sanitizedData = sanitizePayloadData(data);

  const response = await Api.get('/ecomm/internal/order/get', sanitizedData);
  if (!response.success) {
    console.error('Error on ecom/getEcomOrderListThunk');
  }
  return response;
});
